class BlockWrapSlider {
	constructor() {
		const sliders = document.querySelectorAll(".block-wrap-slider");
		sliders.forEach(slider => {
			const prev = slider.querySelector(".button-prev");
			const next = slider.querySelector(".button-next");
			new Swiper(slider.querySelector('.slider'), {
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				navigation: {
					nextEl: next,
					prevEl: prev
				}
			});
		});
	}
}
